export const DEFAULT_PRO_SMS_CODE = '78465';
export const DEFAULT_NON_PRO_SMS_CODE = '38698';
export const IOS_SMS_LINK = 'https://bcrw.apple.com/urn:biz:88d22123-779e-11e7-a907-c753b1bff6fa';